// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDacfeecountIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDacfeecountIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDacfeecountIconOutlined = function DrrpDacfeecountIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDacfeecountIconOutlinedSvg
  }));
};

DrrpDacfeecountIconOutlined.displayName = 'DrrpDacfeecountIconOutlined';
export default React.forwardRef(DrrpDacfeecountIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDacfeecountIconOutlined.js
// module id = 2501
// module chunks = 0